// extracted by mini-css-extract-plugin
export var pillWrapper = "_nv-0";
export var showOverflow = "_nv-1";